import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth-service';

@Component({
    templateUrl: './sign-in.component.html',
    standalone: false
})
export class SignInComponent implements OnInit {
    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.authService.userManager.signinRedirectCallback().then((user) => {
            const url = user.state as string;
            if (url) {
                try {
                    if (new URL(url, window.location.href).origin === window.location.origin) {
                        window.location.href = url;
                    }
                } catch { /* invalid URL */ }
            }
        });
    }
}
